import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sum',
    pure: false
})
export class SumPipe implements PipeTransform {
    transform(items: any[], attr: string): any {
        if (!items || !items.length) return items;
        return items.reduce((a, b) => a + b[attr], 0);
    }
}
